
import { Component, Vue } from 'vue-property-decorator';
import { RemoteFeatureFlagsModule } from '~/store/modules/remoteFeatureFlags';
import { humanReadableDate } from '~common-filters/humanReadableDate';

@Component({
    filters: {
        humanReadableDate,
    },
})
export default class CurrentUserFlags extends Vue {
    selectedFlag: string | null = null;

    get currentUserFlags() {
        return RemoteFeatureFlagsModule.currentUserFlags;
    }
    async removeUserFlag(flagId: string) {
        await RemoteFeatureFlagsModule.removeFlagFromUser(flagId);
    }
}
